export default __webpack_public_path__ + "static/media/doc3.99de17dc.jpeg";